import { render } from "./tdcRequests.vue?vue&type=template&id=7b86a306&scoped=true"
import script from "./tdcRequests.vue?vue&type=script&lang=js"
export * from "./tdcRequests.vue?vue&type=script&lang=js"

import "./tdcRequests.vue?vue&type=style&index=0&id=7b86a306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b86a306"]])

export default __exports__